import {getCurrentYear} from '../../utils/commons'
import TopHomeProductReviewsLogo from './logo'
import {topHomeProductReviewsStylesCA, topHomeProductReviewsStylesUK} from './styles'

const baseConfig = {
  domainName: 'tophomeproductreviews' as const,
  siteName: 'Top Home Product Reviews',
  favicon: '/favicons/tophomeproductreviews.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-W491376DRR',
    domainType: 'eu' as const,
    camelCaseUrl: 'TopHomeProductReviews.co.uk',
    logo: <TopHomeProductReviewsLogo className="size-9 shrink-0 tablet:size-7" locale="uk" />,
    title: (category: string, _count: string) =>
      `Top Reviewed ${category} ${getCurrentYear()} in the UK | TopHomeProductReviews.co.uk – Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `At TopHomeProductReviews.co.uk, we curated the best ranked household essentials for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights to make smart choices for your home.`,
    styles: topHomeProductReviewsStylesUK,
  },
  ca: {
    measurementId: 'G-KK3FGV8BEF',
    domainType: 'picks' as const,
    camelCaseUrl: 'TopHomeProductReviews.ca',
    logo: <TopHomeProductReviewsLogo className="size-9 shrink-0 tablet:size-7" locale="ca" />,
    title: (category: string, _count: string) =>
      `Top Reviewed ${category} ${getCurrentYear()} in CA | TopHomeProductReviews.ca– Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `At TopHomeProductReviews.ca, we curated the best ranked household essentials for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights to make smart choices for your home.`,
    styles: topHomeProductReviewsStylesCA,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
